import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { getLocalstorage } from "../../helper";

export default class TermsConditions extends Component {
  render() {
    const { show, closeModal } = this.props;
    let isLoggedIn = !!getLocalstorage("token");
    const emailId = isLoggedIn
      ? " pmg@investindia.org.in"
      : " pmg[at]investindia[dot]org[dot]in";
    return (
      <React.Fragment>
        <Modal show={show} dialogClassName="banner-modal" onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Terms & Conditions</Modal.Title>
          </Modal.Header>
          <Modal.Body className="terms-conditions">
            <div>
              This website is owned and operated by Project Monitoring Group
              (PMG), Invest India. You should read these terms carefully before
              using this website. Invest India reserves all rights in respect of
              this website.
            </div>
            <div>
              The Project Monitoring Group (PMG), Invest India is an
              institutional mechanism for the expedited resolution of issues and
              regulatory bottlenecks in projects. The documents and information
              displayed in this website are for reference purposes only and does
              not purport to be a legal document.
            </div>
            <div>
              Neither Department for Promotion of Industry & Internal Trade
              (DPIIT), Ministry of Commerce and Industry, Government of India,
              nor Invest India does warrant the accuracy or completeness of the
              information, text, graphics, links or other items contained within
              the Project Monitoring Group platform. As a result of updates and
              corrections, the web contents are subject to change regularly.
            </div>
            <div>
              The information posted on this website could include hypertext
              links or pointers to information created and maintained by
              non-Government/private organisations. PMG is providing these links
              and pointers solely for your information and convenience.
            </div>
            <div>
              These terms and conditions shall be governed by and construed in
              accordance with the Indian Laws. Any dispute arising under these
              terms and conditions shall be subject to the jurisdiction of the
              courts of India.
            </div>
            <div>
              By accessing or using this website, you unconditionally agree to
              these Terms and as they may be modified and/or supplemented any
              time by Invest India without notice. If you do not agree to be
              bound by these terms, we request you to please redirect from the
              website.
            </div>
            <h1>Changes since the previous version of this notice</h1>
            <div>None. This is the first version.</div>
            <h1>What data does Project Monitoring Group collect?</h1>
            <div>
              We collect Basic Personal Data from you, and we are the
              "Controller" of this data. This includes your user ID, name, email
              address and related information you may provide (for example, your
              organization details). We also collect information about your
              network connection(s) such as your IP Address. If we require more
              personal data, we will notify you. For full information about how
              we use your personal data, please refer to our Privacy Statement.
            </div>
            <h1>Why Project Monitoring Group needs your data?</h1>
            <div>
              We need your Basic Personal Data to support our legitimate
              interests in enabling you to create and use a PMG ID. This allows
              you to access information and services, and to manage your account
              settings and preferences.
            </div>
            <div>
              If you do not want us to use your Basic Personal Data as described
              above, you have the option of not using your PMG ID, or even
              asking us to delete your PMG ID.
            </div>
            <h1>How your data was obtained?</h1>
            <div>
              This is how we obtained your Basic Personal Data when your PMG ID
              was created:
            </div>
            <ul>
              <li>
                When using the PMG registration process, your Basic Personal
                Data would have been entered by you.
              </li>
              <li>
                Your IP Address is obtained when you make a network connection
                to us.
              </li>
            </ul>
            <h1>How PMG uses your data?</h1>
            <div>This is how PMG ID uses your Basic Personal Data:</div>
            <ul>
              <li>
                To uniquely identify you, and to supply your authenticated
                identity to PMG or third party applications and services
              </li>
              <li>To communicate with you about your PMG ID</li>
              <li>
                To perform security/audit logging, including in conjunction with
                your IP Address
              </li>
              <li>
                To perform problem determination, system administration, usage
                tracking, and support activities and
              </li>
              <li>
                To set secure cookies which maintain your authenticated user
                session.
              </li>
            </ul>
            <div>
              Applications and services may use your Basic Personal Data in
              these ways:
            </div>
            <ul>
              <li>To uniquely identify you</li>
              <li>To communicate with you about your Account status</li>
              <li>To authorize your level of access</li>
              <li>
                To reflect your Basic Personal Data to you (for example, an
                on-screen greeting)
              </li>
              <li>
                To perform security/audit logging, including in conjunction with
                your IP Address
              </li>
              <li>
                To perform problem determination, system administration,
                subscription management, usage tracking, and support activities
                and
              </li>
              <li>
                To set secure cookies which maintain your authenticated user
                session(s) with applications or services.
              </li>
              <div>
                Where appropriate, Invest India may use selected partners to
                process your Basic Personal Data.
              </div>
              <div>
                Applications or services which use your Basic Personal Data for
                purposes different than those above will provide you with
                notification, or when appropriate, an opportunity to consent to
                such use.
              </div>
              <div>
                If you do not wish your Basic Personal Data to be used for the
                above purposes, you have the option of not using your PMG ID, or
                even asking us to delete your PMG ID.
              </div>
            </ul>
            <h1>How PMG protects your data?</h1>
            <div>
              For the legitimate interests explained above under "Why we need
              your data", your Basic Personal Data is protected in these ways:
            </div>
            <ul>
              <li>
                When appropriate, we use secure communications and storage to
                protect your personal data from unauthorized access or
                disclosure.
              </li>
              <li>
                We require applications or services which use your personal data
                for purposes other than those described here to justify those
                uses, provide appropriate notice, and where applicable, allow
                you to consent to such usage.
              </li>
            </ul>
            <h1>How long we keep your data?</h1>
            <div>
              Invest India will keep your Basic Personal Data while you have an
              active PMG ID. If you choose to delete your PMG ID, we will delete
              your data. However, data already present in security or audit
              logs, support records, or business transaction records, may be
              retained for those purposes. Our retention policies determine how
              long we will retain this data. For additional information
              regarding data retention, refer to our Privacy Statement.
            </div>
            <h1>Your rights</h1>
            <div>
              Our Privacy Statement provides more information about your
              personal data rights. It also provides contact information if you
              have questions or concerns regarding our handling of your personal
              data.
            </div>
            <h1>Ownership, use and intellectual property rights</h1>
            <div>
              This website and all intellectual property rights in it, including
              but not limited to any content, are owned by PMG, Invest India.
              PMG, Invest India reserves all its rights in any intellectual
              property in connection with these Terms.
            </div>
            <div>
              Where third party intellectual property rights are involved in the
              non-text contents found on this website, authorisation or
              permission to reproduce or distribute or otherwise use any such
              non-text contents must be obtained from the intellectual property
              owners concerned.
            </div>
            <div>
              If you intend to reproduce, distribute or otherwise use any
              contents on any linked websites, you shall obtain all necessary
              authorisation or permission from the intellectual property owners
              concerned.
            </div>
            <h1>Disclaimer of warranties and liability</h1>
            <div>
              This website has been compiled in good faith by Invest India.
            </div>
            <div>
              While every effort has been made to ensure accuracy, the
              information on this website is provided to you on an "AS IS" basis
              for a general, indicative purpose only without any express or
              implied warranty as to the accuracy, completeness, relevance or
              fitness of the materials on this website for any particular
              purpose.
            </div>
            <div>
              You are responsible for making your own assessment of all
              information contained on the website. This website and information
              contained therein is not a substitute for independent professional
              advice and users should obtain any appropriate professional advice
              relevant to their particular circumstances. This website does not,
              in any case, replace professional guidance on matters concerning
              accounting, tax, the law or other such specific areas.
            </div>
            <div>
              Any reference to any specific product, process or service by a
              provider, manufacturer or distributor does not constitute or imply
              endorsement or recommendation by Invest India.
            </div>
            <div>
              Invest India will not be liable for any errors, omissions or
              inaccuracies, or misstatements or misrepresentations (whether
              express or implied) concerning any such information on this
              website, and will not have or accept any liability, obligation or
              responsibility whatsoever for any loss, destruction or damage
              (including without limitation consequential loss, destruction or
              damage) however arising from or in respect of any use or misuse of
              or reliance on this website or the information contained therein
              or the inability to use our website.
            </div>
            <h1>Modifications, changes and access</h1>
            <div>
              PMG, Invest India reserves the right to omit, suspend or edit all
              information compiled by Invest India on this website at any time
              in its sole discretion without giving any reason or prior notice.
            </div>
            <div>
              Invest India may at any time modify or discontinue, temporarily or
              permanently, the website (or any part thereof) without notice and
              shall not be liable to you or to any third party for any
              modification, suspension or discontinuance of the website.
            </div>
            <h1>Hyperlinks/ third party websites and materials</h1>
            <div>
              The PMG platform may contain materials contributed by third
              parties. To facilitate access to information provided by or via
              third parties, Invest India may provide or assist in providing
              links to external websites through its webpages.
            </div>
            <div>
              Invest India states that it has not approved or endorsed the
              materials contributed by third parties on the PMG website or any
              external websites linked to this website. The provision of any
              such materials or links to external websites shall not constitute
              any form of co-operation or affiliation with Invest India of any
              such third parties or external websites. Provision of, or
              assistance in providing, materials contributed by third parties on
              the PMG website or links to external websites gives rise to no
              statement, representation or warranty, express or implied, that
              Invest India agrees or does not disagree with the contents of any
              such materials or external websites and Invest India will not have
              or accept any liability, obligation or responsibility whatsoever
              for any loss, destruction or damage (including without limitation
              consequential loss, destruction or damage) however arising from or
              in respect of any use or misuse of or reliance on the contents of
              any such materials or external websites delivered on or via the
              PMG website or inability to use any of them.
            </div>
            <div>
              Invest India has included links to external websites and other
              Government of India initiatives to help users better understand
              India. PMG's inclusion of such links and content does not imply
              any endorsement of any material on linked sites or recommendation
              of that company or provider over another.
            </div>
            <h1>Using the website</h1>
            <div>
              We seek to make the website as accessible as possible. If you have
              any difficulties using the website, please contact us at
              <b> {emailId} </b>
            </div>
            <div>
              We reserve all rights to deny or restrict access to this website
              to any particular person or to block access from a particular
              internet address to this website for any non-compliance with any
              part of these Terms or any applicable law.
            </div>
            <h1>Indemnity</h1>
            <div>
              You agree to indemnify and hold Invest India and its officers,
              agents, contractors, and employees, harmless from any claim or
              demand, including all legal fees, made by any third party due to
              or arising out of your use of the website, your connection to the
              website, your breach of the Terms, or your violation of any rights
              of another.
            </div>
            <h1>Governing law</h1>
            <div>
              The access and use of this website and its materials, and the
              Terms shall be governed by and construed in accordance with the
              laws of the Republic of India.
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
